import { Component } from "@angular/core";
import { ACCESS_TOKEN } from "./services/constants/general.constants";
import { timeApi } from "./services/constants/api.constants";
import {
  AuthService,
  HelpersService,
  LanguageService,
  HttpBaseService,
  ScriptInjectorService,
} from "@evento-ng/libs";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  constructor(
    private languageService: LanguageService,
    private helpers: HelpersService,
    private authService: AuthService,
    private dataService: HttpBaseService,
    private scriptInjectorService: ScriptInjectorService
  ) {
    this.languageService.loadDefaultLangsAndStyles();
    if (
      this.helpers.checkItemFromLocalStorage(ACCESS_TOKEN) &&
      !this.authService.user.getValue()
    ) {
      this.authService.fetchUser();
    }
  }
  ngOnInit() {
    this.getServerTime();

    if (environment.production) {
      this.scriptInjectorService.injectGtm();
    }
  }

  getServerTime() {
    this.dataService.get(timeApi).subscribe((res) => {
      const serverTime = Math.floor(res.currentTime);
      const now = Math.floor(Date.now() / 1000) - 5;
      localStorage.setItem("serverDiff", JSON.stringify(serverTime - now));
    });
  }
}
